import React, { useContext, useMemo } from "react";
import "./DocumentDetail.css";
import Header from "./Header/Header";
import DuplicateNotification from "./DuplicateNotification/DuplicateNotification";
import { DocumentDetailContext } from "./contexts/DocumentDetailContext";
import Flags from "./Flags/Flags";
import FaxPageDrop from "./FaxPageDrop/FaxPageDrop";
import Classification from "./Classification/Classification";
import EhrDetails from "./EHRDetails/EhrDetails";
import DocumentDescription from "./DocumentDescription/DocumentDescription";
import Extraction from "./Extraction/Extraction"
import ButtonHandler from "./ButtonHandler/ButtonHandler";
import DocumentPreview from "./DocumentPreview/DocumentPreview";
import Dialogs from "./Dialogs/Dialogs";
import DocumentSplit from "./DocumentSplit/DocumentSplit";
import * as c from "utils/constants/constants"
import { CircularProgress } from "@mui/material";
import DocumentWarningNotification from "./DocumentWarningNotification/DocumentWarningNotification";
import { Info, Warning } from "@mui/icons-material";

const DocumentDetailWrapper = () => {
    const { data = {},  _baseClassName, loader, docSplit, documentPreviewUrl, isSave } = useContext(DocumentDetailContext);

    const disableEdit = useMemo(() => {
        const { Entity_Details = {} } = data || {};
        const isAdmin = localStorage.getItem(c.USER_ROLE) == "Admin";
        const isCorrectFlag = (data?.Tags || []).some(m => m.tag_display_name == "CORRECT" && m.enabled);
        const isDocumentSpitComplete = docSplit.isDocSplitEnabled && data?.Entity_Details?.enable_doc_split == false && (docSplit.docSplitData || []).some(m => Boolean(m.document_status));
        if (isDocumentSpitComplete) return true;
        if (data?.location == "MTM Value Based" && !isAdmin) return true;
        if(isCorrectFlag && isAdmin) return false;
        if(Entity_Details?.is_block_fax) return true;
        if (data?.Status === c.status.uploading || data?.Status === c.status.completing || data?.Status === c.status.completed ||
            data?.Status === c.status.uploaded || [5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009].includes(data?.Error_Code)) return true
        else if (data?.Status === c.status.uploaded && !Entity_Details.is_epic_confirmation_received) return true;
        else if (Entity_Details?.fax_cover_page_drop?.status == "In Progress") return true; 
        return false;
    }, [data]);

    return loader.pageLoader ? <CircularProgress size={30} className="common-spinner" /> :

        <>
            {loader?.fullLoader && <CircularProgress size={30} className="common-spinner" />}
            <div id="draggable-bound" className={loader.fullLoader ? "block-area-common" : ""} style={{ width: "100%", display: "flex", marginTop: "60px" }}>
                <div className={`${_baseClassName}-container`}>
                    {loader.miniLoader && <CircularProgress size={30} className="common-spinner" />}
                    <div className={loader.miniLoader ? "block-area-common" : ""}>
                        <Header />
                        <ButtonHandler />
                        {data.Entity_Details?.patientMatch?.message && !docSplit.isDocSplitEnabled && <DocumentWarningNotification 
                            bgColor="rgba(255, 127, 80, 1)" 
                            // icon={<Info style={{color: "#fff"}} />}
                            color="#FFF" 
                            message={data.Entity_Details?.patientMatch?.message} 
                        /> }
                        <DuplicateNotification />
                        {data.Entity_Details?.is_spam && !data.Entity_Details.spam_notification_removed && <DocumentWarningNotification 
                            type="spamWarning" 
                            bgColor="rgba(255, 0, 63, 0.6)" 
                            icon={<Warning style={{color: "#FFF"}} />}
                            color="#FFF" 
                            message="This document could be a probable spam"
                            showClose={!isSave}
                        />}
                        {data.Entity_Details?.is_error && !data.Entity_Details.error_notification_removed && <DocumentWarningNotification 
                            type="errorWarning" 
                            bgColor="rgba(255, 0, 63, 0.6)" 
                            icon={<Warning style={{color: "#FFF"}} />}
                            color="#FFF" 
                            message="This document could be a probable fax error document"
                            showClose={!isSave}
                        />}
                        {data.Entity_Details?.is_care_everywhere && <DocumentWarningNotification 
                            type="careEveryWhereWarning" 
                            bgColor="rgba(175, 219, 245, 1)" 
                            icon={<Warning style={{color: "#1560bd"}} />}
                            color="#663c00" 
                            message="This document could be a probable care everywhere"
                            showClose={!isSave}
                        />}
                        <div style={{ margin: "15px 20px", pointerEvents: disableEdit ? "none" : "auto", cursor: disableEdit ? "alias" : "auto" }}>
                            {data.Entity_Details?.is_block_fax ? (
                                <div className="block-fax-container">
                                    <div>Blocked Fax</div>
                                </div>
                            ) : null}
                            <div style={{ display: "flex", marginBottom: "15px" }}>
                                <Flags />
                                {!docSplit.isDocSplitEnabled && data.Page_Count > 1 && !data.Entity_Details.parentDocId && <FaxPageDrop />}
                            </div>
                            {docSplit.isDocSplitEnabled ? <DocumentSplit /> : <>
                                <Extraction disableEdit={disableEdit}/>
                                <Classification />
                                <EhrDetails />
                                <DocumentDescription />
                            </>}
                        </div>
                        <Dialogs />
                    </div>
                </div>
                {Object.keys(data || {})?.length && documentPreviewUrl && <DocumentPreview />}
            </div>
        </>
}

export default DocumentDetailWrapper;